import { useAuth } from "@/lib/AuthContext";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { MessageCircle } from "lucide-react";

export default function ConversationList({ conversations, selectedId, onSelect }) {
  const { user } = useAuth();

  if (conversations.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-40 text-center text-muted-foreground px-4">
        <MessageCircle className="w-8 h-8 mb-2 opacity-40" />
        <p className="text-sm">No conversations yet</p>
      </div>
    );
  }

  return (
    <div className="divide-y divide-border">
      {conversations.map((conv) => {
        const other = conv.otherUser;
        const initials = (other?.full_name || other?.email || "?")
          .split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2);
        const isSelected = selectedId === conv.conversation_id;

        return (
          <button
            key={conv.conversation_id}
            onClick={() => onSelect(conv)}
            className={`w-full flex items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-muted/50 ${
              isSelected ? "bg-primary/10 border-l-2 border-primary" : ""
            }`}
          >
            <Avatar className="w-10 h-10 shrink-0">
              <AvatarFallback className="bg-primary/20 text-primary font-semibold text-sm">
                {initials}
              </AvatarFallback>
            </Avatar>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <p className="text-sm font-semibold truncate">
                  {other?.full_name || other?.email || "Unknown"}
                </p>
                {conv.unreadCount > 0 && (
                  <Badge className="ml-2 h-5 w-5 p-0 flex items-center justify-center text-[10px] bg-primary">
                    {conv.unreadCount}
                  </Badge>
                )}
              </div>
              <p className="text-xs text-muted-foreground truncate mt-0.5">
                {conv.lastMessage?.content || "No messages yet"}
              </p>
            </div>
          </button>
        );
      })}
    </div>
  );
}